/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function Seo({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: `description`,
          content: metaDescription,
          key: `description`,
        },
        {
          property: `og:title`,
          content: title,
          key: `og-title`,
        },
        {
          property: `og:description`,
          content: metaDescription,
          key: `og-description`,
        },
        {
          property: `og:type`,
          content: `website`,
          key: `og-type`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
          key: `twitter-card`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
          key: `twitter-creator`,
        },
        {
          name: `twitter:title`,
          content: title,
          key: `twitter-title`,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
          key: `twitter-description`,
        },
      ].concat(meta)}
    />
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default Seo
